import { Box, Paper, Typography } from "@mui/material";
import Num from "./Num";

/**
 * Bitta ko'rsatkich. Raqam -- asosiy narsa, shuning uchun u eng katta va
 * mono shriftda; yorliq ustida kichik matn bilan turadi.
 */
const StatCard = ({ label, value, suffix, hint, accent, icon }) => (
  <Paper
    sx={{
      p: 2.5,
      display: "flex",
      flexDirection: "column",
      gap: 0.5,
      height: "100%",
      position: "relative",
      overflow: "hidden",
    }}
  >
    {accent && (
      <Box
        sx={{
          position: "absolute", left: 0, top: 0, bottom: 0, width: 3,
          bgcolor: accent,
        }}
      />
    )}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography variant="overline" color="text.secondary" sx={{ flexGrow: 1 }}>
        {label}
      </Typography>
      {icon && <Box sx={{ color: "text.secondary", display: "flex", fontSize: 16 }}>{icon}</Box>}
    </Box>
    <Num value={value} suffix={suffix} size="1.75rem" weight={600} />
    {hint && (
      <Typography variant="caption" color="text.secondary">
        {hint}
      </Typography>
    )}
  </Paper>
);

export default StatCard;
